import axios from 'axios';
import { DluchApi } from '../constants/SharedComponents';
import secureLocalStorage from 'react-secure-storage';
import RefreshToken from './RefreshToken';

let msalInstance = null;
let navigate = null;

export const setAuthContext = (instance, nav) => {
    msalInstance = instance;
    navigate = nav;
};

const axiosInstance = axios.create({
    baseURL: new DluchApi(''),
    timeout: 30000,
});

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response && (error.response.status === 401 || (error.response.status === 403 && !error.response.data) || (error.response.status === 403 
            && !error.response.data?.errorDesc.toLowerCase().includes('sign in with microsoft')))) 
        {
            try {
                const refresh = new RefreshToken(msalInstance, navigate);
                const newUserToken = await refresh.tokenRefresh();

                const originalRequest = error.config;
                originalRequest.headers.Authorization = `Bearer ${newUserToken}`;
                return await axios(originalRequest);
            }
            catch (refreshError) {
                navigate('/sessions/new');
                secureLocalStorage.removeItem('userDetails');
                return Promise.reject(new Error(refreshError, `Error: ${refreshError}`, refreshError));
            }
        }

        if (error.response.data?.errorDesc){
            if (error.response.data.errorDesc.toLowerCase().includes('sign in with microsoft')){
                return Promise.reject(new Error("Your organisation has Single Sign-On (SSO) enabled. Please use the 'Sign in with Microsoft' button to sign in.", `${error.response.data.errorDesc}`, error.response.data.errorDesc));
            }
            return Promise.reject(new Error(error.response.data.errorDesc, `${error.response.data.errorDesc}`, error.response.data.errorDesc));
        }

        return Promise.reject(new Error(error, `Error: ${error}`, error));
    }
);

export default axiosInstance;
